import React from 'react';

const GROUPS = [
  {
    val: 'kids',
    icon: 'child',
    label: 'Bringing the kids',
    sub: 'Families with children — we need lifeguards, playgrounds, and kid-friendly beaches',
  },
  {
    val: 'teens',
    icon: 'user-friends',
    label: 'Teens / group of friends (under 21)',
    sub: 'A crew looking for beach freedom, good food, and something to explore',
  },
  {
    val: 'adults',
    icon: 'glass-cheers',
    label: 'Adults only',
    sub: 'A group of adults — open to everything the island has to offer',
  },
  {
    val: 'mixed',
    icon: 'users',
    label: 'Mixed group',
    sub: 'A mix of ages — we need something that works for everyone',
  },
  {
    val: 'solo',
    icon: 'user',
    label: 'Just me',
    sub: 'Flying solo — I want to explore at my own pace',
  },
];

const GroupStep = ({ group, onPick, onBack, onNext }) => (
  <div>
    <div className="step-eyebrow">Step 1.5 of 3</div>
    <div className="step-title">Who's coming with you?</div>
    <div className="step-subtitle">
      This helps us tailor the recommendation to your group.
    </div>
    <div className="group-options">
      {GROUPS.map((g) => (
        <button
          type="button"
          key={g.val}
          className={`option-btn group-btn${group === g.val ? ' selected' : ''}`}
          onClick={() => onPick(g.val)}
        >
          <i className={`far fa-${g.icon} option-icon`} />
          <strong>{g.label}</strong>
          <span className="group-sub">{g.sub}</span>
        </button>
      ))}
    </div>
    <div className="quiz-footer">
      <button type="button" className="back-btn" onClick={onBack}>
        ← Back
      </button>
      <button
        type="button"
        className={`next-btn${group ? ' active' : ''}`}
        disabled={!group}
        onClick={onNext}
      >
        Next →
      </button>
    </div>
  </div>
);

export default GroupStep;
